import { FC, useEffect } from "react";
import confetti from "canvas-confetti";
import { useSound } from "../../../../../hooks";
import DancingAvatar from "../../../DancingAvatar/DancingAvatar";
import Krown from "../../../../../assets/icons/Krown.svg";
import Star from "../../../../../assets/icons/Star.svg";


interface CustomHTMLElement extends HTMLCanvasElement{
    confetti: any;
}

interface IAvatars {
    playerWithMostUpper: any;
}

const Avatars: FC<IAvatars> = (props) => {
    let { playerWithMostUpper } = props;
    const {playSound} = useSound();
    
    useEffect(() => {
        playSound("/sounds/AudienceCheering.mp3");
       
    },[playSound]);

    useEffect(() => {
        addConfetti();
    }, [])

    const addConfetti = () => {
        const htmlCanvas = document.getElementById("confeti") as CustomHTMLElement;
        
        htmlCanvas!.confetti = htmlCanvas!.confetti || confetti.create(htmlCanvas, { resize: true });
        htmlCanvas!.confetti({
            particleCount: 300,
            angle: 90,
            spread: 180,
            gravity: 1,
            zIndex: 1,
            startVelocity: 50,
            scalar: 3,
            colors: ["#53BD8B", "#FF00A7", "#005776", "#FED100" ],
            resize: true
        });
    }

    const checkUpperForSecondPlayer : any = (firstPlace: any, secondPlace: any) => {
        if (secondPlace?.upper === firstPlace?.upper)
            return Krown

        return Star
    }

    const checkUpperForThirdPlayer : any = (firstPlace: any ,secondPlace: any, thirdPlace: any) => {
        if (thirdPlace?.upper === firstPlace?.upper) 
            return Krown;
        
        if (thirdPlace?.upper === secondPlace?.upper)
            return Star;
        
        return; 
    }

    const checkSecondPlayerPlace : any = (firstPlace: any, secondPlace: any) => {
        if (secondPlace?.upper === firstPlace?.upper)
            return "1";
        
        return "2";
    }

    const checkThirdPlayerPlace : any = (firstPlace: any, secondPlace: any, thirdPlace: any) => {
        if (thirdPlace?.upper === firstPlace?.upper)
            return "1";
        
        if (thirdPlace?.upper === secondPlace?.upper)
            return "2";

        return "3";
    }

    if (!playerWithMostUpper){
        return(<div></div>) 
    }

    return (
        <div className="avatars_and_podium_container">
            <canvas id="confeti" style={{position: 'absolute', width:'99%', zIndex: 1, borderRadius:'50%', left:0}} />
            <DancingAvatar placeOnPodium="second_podium" icon={checkUpperForSecondPlayer(playerWithMostUpper[0], playerWithMostUpper[1])} color={playerWithMostUpper[1].color} place={checkSecondPlayerPlace(playerWithMostUpper[0], playerWithMostUpper[1])} />
            <DancingAvatar placeOnPodium="first_podium"  icon={Krown} color={playerWithMostUpper[0].color} place="1" />
            { playerWithMostUpper.length > 2 &&  <DancingAvatar placeOnPodium="third_podium"  icon={checkUpperForThirdPlayer(playerWithMostUpper[0], playerWithMostUpper[1], playerWithMostUpper[2])} color={playerWithMostUpper[2].color} place={checkThirdPlayerPlace(playerWithMostUpper[0], playerWithMostUpper[1], playerWithMostUpper[2])} />}
        </div>
    )
};

export default Avatars;